export default __webpack_public_path__ + "static/media/dashboard.c9e780c5.svg";